import React from 'react'

function CollectionHub() {
  return (
    <div className="collection-hub">
      <h1 className='collection-hub__title'>Discover Curated 3D Model Collections</h1>
    </div>
  )
}

CollectionHub.propTypes = {}

export default CollectionHub
